import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Main from '@/pages/Main'
import User from '@/pages/User'
import Log from '@/pages/Log'
import About from '@/pages/About'
import ChangeLog from '@/pages/Changes'
import CardInfo from '@/pages/CardInfo'
import firebase from 'firebase'
import Emergency from '@/pages/Emergency'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/log',
      name: 'Log',
      component: Log,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/changelog',
      name: 'ChangeLog',
      component: ChangeLog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cardinfo',
      name: 'CardInfo',
      component: CardInfo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/emergency',
      name: 'Emergency',
      component: Emergency,
      meta: {
        requiresAuth: true
      }
    }
  ]
})
// Nav Guards
router.beforeEach((to, from, next) => {
  // Check for requiredAuth guard
  if(to.matched.some(record => record.meta.requiresAuth)){
    // Check if NOT logged in
    if(!firebase.auth().currentUser){
      // Go to login page
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Procedd to route
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if logged in
    if(firebase.auth().currentUser){
      // Go to login page
      next({
        path: '/main',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Procedd to route
      next()
    }
  } else {
    // Procedd to route
    next()
  }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js